/* eslint-disable @typescript-eslint/no-explicit-any */

import { API } from 'api/config'
import { contentCategory } from 'interfaces'
import { captureErrorSentry, SentryEvents, SentrySections } from 'utils'

export interface GetCalendarDataPromise {
	id: number
	title: string
	description: string
	content_category: contentCategory
	status: string
	type: string
	created_at: Date
	release_date: string | null
	expiration_date: string | null
	repeating_schedule: boolean
	repeat_start_date: null
	repeat_every_type: null
	repeat_every_value: null
	repeat_on: null
	repeat_end_type: null
	repeat_end_value: null
	has_notification: boolean | null
	publish_date: string
	expirate_date: string | null
	organization_id: number
	assets: Array<string>
	card_expirated: boolean
}

export const getCalendarData = async (
	organizationId: number,
	params?: {
		date_filter_type: 'week' | 'month'
		selected_date: string
		search?: string
		content_category?: string
		status?: string
		only_notifications?: boolean
	}
): Promise<Array<GetCalendarDataPromise>> => {
	const filteredParams = Object.fromEntries(
		Object.entries(params || {}).filter(
			([, value]) => value !== undefined && value !== null && value !== ''
		)
	)

	try {
		const response = await API().get(
			`/calendar/organizations/${organizationId}`,
			{
				params: filteredParams
			}
		)
		return response.data
	} catch (error: any) {
		captureErrorSentry({
			section: SentrySections.CALENDAR,
			event: SentryEvents.GET_CALENDAR_DATA_ERROR,
			error,
			extra: {
				organizationId,
				params: filteredParams
			}
		})
		const message =
			error?.response?.data?.detail || error?.message || 'Internal error server'

		throw new Error(message)
	}
}
